// extracted by mini-css-extract-plugin
module.exports = {"loadingForm":"LoadingForm_loadingForm__Vtt1u"};